'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LoginForm;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _hookHandleChange = _interopRequireDefault(require("Components/Forms/Functions/hookHandleChange"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
var _ajaxRequest = _interopRequireDefault(require("Functions/ajax/ajaxRequest"));
var _bemit = _interopRequireDefault(require("Functions/bemit"));
var _Routing = require("Functions/Routing");
const _excluded = ["statement", "error", "info", "warning"];
let app = window.app;
const qwest = window.qwest;
const DEFAULT_ERROR = 'Connexion impossible, veuillez rententer ' + 'ultérieurement.';
function LoginForm(props) {
  let navigate = (0, _reactRouterDom.useNavigate)();
  const [status_messages, setStatusMessages] = (0, _react.useState)({});
  const [status, setStatus] = (0, _react.useState)({});
  const [loading, setLoading] = (0, _react.useState)(false);
  const [form, setForm] = (0, _react.useState)({});
  const hookedHandleChange = _hookHandleChange.default.bind({
    form,
    setForm,
    status_messages,
    setStatusMessages,
    setStatus
  });
  (0, _react.useEffect)(() => {
    if (app.state.form_error) {
      setStatus({
        error: app.state.form_error
      });
      app.state.form_error = undefined;
    }
  }, []);
  const loader = loading === true ? /*#__PURE__*/React.createElement(_Loader.default, {
    className: "c-loader",
    bemit: ['white', 'bg-primary']
  }) : undefined;
  let output = /*#__PURE__*/React.createElement("form", {
    method: "POST",
    action: "/login",
    className: "login-page__form",
    onSubmit: login
  }, /*#__PURE__*/React.createElement(_TextInput.default, {
    onChange: hookedHandleChange,
    value: form['email'],
    name: "email",
    label: "E-mail",
    type: "email",
    autoComplete: "current-email",
    status: status_messages
  }), /*#__PURE__*/React.createElement(_TextInput.default, {
    onChange: hookedHandleChange,
    value: form['password'],
    name: "password",
    label: "Mot de passe",
    type: "password",
    className: "u-margin-top-10",
    autoComplete: "current-password",
    status: status_messages
  }), /*#__PURE__*/React.createElement("div", {
    className: "u-full-width u-text-right u-margin-top-20"
  }, /*#__PURE__*/React.createElement(_Button.default, {
    color: "secondary",
    size: "small",
    href: (0, _Routing.URL)('PasswordRecovery')
  }, "Mot de passe oubli\xE9\xA0?")), (0, _getFormStatus.default)(status), /*#__PURE__*/React.createElement("div", {
    className: "u-full-width u-margin-top-25 u-text-center"
  }, /*#__PURE__*/React.createElement(_Button.default, {
    type: "submit",
    className: (0, _bemit.default)('c-flat-btn', ['primary'])
  }, "Je me connecte", loader), /*#__PURE__*/React.createElement("span", {
    className: "u-padding-left-15"
  }, "ou"), /*#__PURE__*/React.createElement(_Button.default, {
    className: "u-padding-left-15",
    color: "primary",
    size: "small",
    href: (0, _Routing.URL)('nouvel-utilisateur')
  }, "Je m'inscris")));
  return output;
  async function login(e) {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await (0, _ajaxRequest.default)((0, _Routing.action)('log-user'), {
        data: {
          login: form.email,
          password: form.password
        }
      });
    } catch (update) {
      const {
          statement,
          error,
          info,
          warning
        } = update,
        status_messages = (0, _objectWithoutProperties2.default)(update, _excluded);
      setStatus({
        statement,
        error,
        info,
        warning
      });
      setStatusMessages(status_messages);
      return setLoading(false);
    }
    setLoading(false);

    // Update user permissions now that user is connected
    app.emit({
      event: 'sessionNeedsRefresh',
      source: 'login',
      data: {
        update_routes: true,
        then: function () {
          navigate((0, _Routing.URL)('/accueil'));
        }
      }
    });
  }
}
